(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-promo-circles"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.ppCirclesSwipeReady) return;
    window.ppCirclesSwipeReady = true;

    const mobile = window.matchMedia('(max-width: 768px)');
    let gesture = null;

    document.addEventListener('pointerdown', (event) => {
      if (!mobile.matches || event.pointerType !== 'touch') return;
      if (!(event.target instanceof Element)) return;

      const carousel = event.target.closest('.pp-circles pp-carousel');
      if (!carousel) return;

      const track = carousel.querySelector('.pp-circles__track');

      gesture = {
        pointerId: event.pointerId,
        carousel,
        track,
        startX: event.clientX,
        startY: event.clientY,
        startCarouselScroll: carousel.scrollLeft,
        startTrackScroll: track ? track.scrollLeft : 0,
        startTransform: track ? getComputedStyle(track).transform : ''
      };
    }, true);

    document.addEventListener('pointerup', (event) => {
      if (!gesture || event.pointerId !== gesture.pointerId) return;

      const {
        carousel,
        track,
        startX,
        startY,
        startCarouselScroll,
        startTrackScroll,
        startTransform
      } = gesture;

      gesture = null;

      if (!mobile.matches) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      const horizontal = Math.abs(deltaX) > Math.abs(deltaY);

      if (!horizontal || Math.abs(deltaX) <= 12) return;

      /* O movimento horizontal não deve abrir o link da categoria. */
      carousel.dataset.ppCirclesBlockClickUntil = String(Date.now() + 600);

      if (Math.abs(deltaX) < 45) return;

      setTimeout(() => {
        if (!carousel.isConnected || !mobile.matches) return;

        /* Não avança duas vezes caso o carrossel já tenha tratado o gesto. */
        const movedByTheme =
          Math.abs(carousel.scrollLeft - startCarouselScroll) > 10 ||
          (
            track &&
            (
              Math.abs(track.scrollLeft - startTrackScroll) > 10 ||
              getComputedStyle(track).transform !== startTransform
            )
          );

        if (movedByTheme) return;

        const section = carousel.closest('.pp-circles');
        const direction = deltaX < 0 ? 'next' : 'prev';
        const control = section?.querySelector(
          `.pp-circles__swipe-controls [data-carousel-${direction}]`
        );

        control?.click();
      }, 0);
    }, true);

    document.addEventListener('pointercancel', (event) => {
      if (gesture && event.pointerId === gesture.pointerId) {
        gesture = null;
      }
    }, true);

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const item = event.target.closest('.pp-circles__item');
      if (!item) return;

      const carousel = item.closest('pp-carousel');
      if (
        carousel &&
        Number(carousel.dataset.ppCirclesBlockClickUntil || 0) > Date.now()
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.ppSlideshowControlsReady) return;
    window.ppSlideshowControlsReady = true;

    let gesture = null;

    function dotsOf(slideshow) {
      return Array.from(
        slideshow.querySelectorAll('.pp-slideshow__dots button')
      );
    }

    function activeIndex(dots) {
      return Math.max(
        0,
        dots.findIndex(
          (dot) => dot.getAttribute('aria-current') === 'true'
        )
      );
    }

    function changeSlide(slideshow, direction) {
      const dots = dotsOf(slideshow);
      if (dots.length < 2) return;

      const next = (activeIndex(dots) + direction + dots.length) % dots.length;
      dots[next].click();
    }

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const slideshow = event.target.closest('pp-slideshow');
      if (!slideshow) return;

      const slideLink = event.target.closest('.pp-slide[href]');

      if (
        slideLink &&
        Number(slideshow.dataset.ppPreventClickUntil || 0) > Date.now()
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      const arrow = event.target.closest('.pp-slideshow__arrow');
      if (!arrow) return;

      event.preventDefault();
      event.stopPropagation();
      changeSlide(slideshow, Number(arrow.dataset.ppDirection));
    }, true);

    document.addEventListener('dragstart', (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest('pp-slideshow .pp-slide')
      ) {
        event.preventDefault();
      }
    });

    document.addEventListener('pointerdown', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      if (
        event.target.closest(
          '.pp-slideshow__arrow, .pp-slideshow__dots'
        )
      ) {
        return;
      }

      const slideshow = event.target.closest('pp-slideshow');
      if (!slideshow || dotsOf(slideshow).length < 2) return;

      gesture = {
        pointerId: event.pointerId,
        slideshow,
        startX: event.clientX,
        startY: event.clientY,
        startIndex: activeIndex(dotsOf(slideshow))
      };
    }, true);

    document.addEventListener('pointerup', (event) => {
      if (!gesture || gesture.pointerId !== event.pointerId) return;

      const { slideshow, startX, startY, startIndex } = gesture;
      gesture = null;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (
        Math.abs(deltaX) <= 12 ||
        Math.abs(deltaX) <= Math.abs(deltaY)
      ) {
        return;
      }

      slideshow.dataset.ppPreventClickUntil = String(Date.now() + 600);

      if (Math.abs(deltaX) < 45) return;

      setTimeout(() => {
        /* Evita avançar duas vezes se o tema já tratou o arraste. */
        if (activeIndex(dotsOf(slideshow)) === startIndex) {
          changeSlide(slideshow, deltaX < 0 ? 1 : -1);
        }
      }, 0);
    }, true);

    document.addEventListener('pointercancel', () => {
      gesture = null;
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
